import { useUser } from './useUser'

export default useUser
